import lazuliskirt1 from "../../../image/flirty-lazuli/lazuliskirt1.webp";
import lazulitop1 from "../../../image/flirty-lazuli/lazulitop1.webp";
import lazulitwopiece from "../../../image/flirty-lazuli/twopiece1.webp";

import selene1 from "../../../image/selene-collection/selenebottom.webp";
import selenedress from "../../../image/selene-collection/selenedress1.webp";
import shorts1 from "../../../image/selene-collection/seleneshorts.webp";
import top1 from "../../../image/selene-collection/selenetop.webp";
import pants1 from "../../../image/selene-collection/selenepants.webp";

import artronaut from "../../../image/stickers/artronaut1.webp";
import iam from "../../../image/stickers/iam1.webp";
import just from "../../../image/stickers/justa.webp";

import purse1 from "../../../image/purses/purses1.webp";

import Collection from "../Collection";

const Merch = () => {
  const items = [
    {
      title: "'Without RT' Sticker",
      imageUrl: just,
      projectUrl: "/Without",
    },
    {
      title: "aRT Sticker Bundle",
      imageUrl: artronaut,
      projectUrl: "/StickerBundle",
    },
    {
      title: "Selene Princess Swimwear High Waisted Reversible Bikini Bottom",
      imageUrl: selene1,
      projectUrl: "/Shop",
    },
    {
      title: "Selene Princess High Waisted Workout Shorts",
      imageUrl: shorts1,
      projectUrl: "/SeleneShorts",
    },
    {
      title: "Selene Princess Workout Pants",
      imageUrl: pants1,
      projectUrl: "/SelenePants",
    },
    {
      title: "Selene Princess revesible Swimwear and Workout Top",
      imageUrl: top1,
      projectUrl: "/SeleneBikiniTop",
    },
    {
      title: "Selene Princess Dress",
      imageUrl: selenedress,
      projectUrl: "/SeleneDress",
    },
    {
      title: "Flirty Lazuli Two Piece Dress",
      imageUrl: lazulitwopiece,
      projectUrl: "/FlirtyLazuliTwoPiece",
    },
    {
      title: "Flirty Lazuli Skirt",
      imageUrl: lazuliskirt1,
      projectUrl: "/FlirtyLazuliSkirt",
    },
    {
      title: "Flirty Lazuli Tops",
      imageUrl: lazulitop1,
      projectUrl: "/FlirtyLazuliTop",
    },
    {
      title: "All Star Purse",
      imageUrl: purse1,
      projectUrl: "/AllStarPurse",
    },
    {
      title: "aRTronaut Sticker",
      imageUrl: iam,
      projectUrl: "/RTronaut",
    },
  ];

  return (
    <Collection
      items={items}
      title="Wearable Art & Thangz"
      variant="boutique"
      eyebrow="Wearable Art"
      description="Selene Princess, Flirty Lazuli, stickers, purses, and other art-forward pieces made to be lived in."
      backgroundImage={lazulitwopiece}
      pageClassName="collection-page--merch"
      showFooter
    />
  );
};

export default Merch;
